module.exports = function getResource(label, vars = []) {
    let resources = {
        member: 'Member',
        join: 'Join',
        new: `${vars[0]} new`
    };
    return resources[label];
};
